export default "__VITE_ASSET__eb245ad7__"